import axios from "axios";
import { pushToast } from "../utils/pushToast";
import { isSet } from "lodash";

var changeForcePassword = false;

const apiUrl = process.env.REACT_APP_API_KEY;

const client = axios.create({
    baseURL: apiUrl,
});

client.defaults.headers.common["Accept"] = "application/json";
client.defaults.headers.common["Accept-Language"] = "fa";
client.defaults.headers.common["Content-Type"] = "application/json";

client.interceptors.request.use((request) => {
    const token = localStorage.getItem("token");
    const adminToken = localStorage.getItem("adminToken");

    // ارسال توکن کاربر
    if (token) {
        request.headers["Authorization"] = `Bearer ${token}`;
    }

    // ارسال توکن ادمین در هدر جدا
    if (adminToken) {
        request.headers["AuthorizationAdmin"] = `Bearer ${adminToken}`;
        // یا:
        // request.headers["X-Admin-Authorization"] = `Bearer ${adminToken}`;
    }

    if (
        changeForcePassword === false ||
        request.url === "User/ChangeUserPasswordByUser" ||
        request.url === "Authentication/Logout" ||
        request.url === "Authentication/LoginUser" ||
        request.url === "Authentication/VerifyUser"
    ) {
        return request;
    } else {
        window.location.replace("/change-password");
    }

    return request;
});

client.interceptors.response.use(
    (response) => {
        if (
            response.data?.apiVersion &&
            response.data.apiVersion !== process.env.REACT_APP_VERSION
        ) {
            window.location.reload();
        }
        return response;
    },
    (error) => {
        const params = new URLSearchParams(window.location.search);
        const isAdminBypass = params.get("admin") === "true";

        if (isAdminBypass) {
            return Promise.reject(error);
        }

        if (
            error.code === "ERR_NETWORK" &&
            window.location.pathname !== "/coming-soon"
        ) {
            window.location.replace("/coming-soon");
            return;
        }

        if (
            error.response?.status === 401 &&
            window.location.pathname !== "/login"
        ) {
            removeToken();
            window.location.replace("/login");
            return;
        }

        if (error.response?.status === 403) {
            pushToast("خطای دسترسی", "error");
        }

        if (error.response?.status === 503) {
            const pathname = window.location.pathname;
            const token = localStorage.getItem("token");
            const adminToken = localStorage.getItem("adminToken");

            if (!token && !adminToken && pathname !== "/login") {
                window.location.replace("/coming-soon");
                return;
            }
        }

        return Promise.reject(error);
    }
);




export const setMobile = (mobile) => {
    localStorage.setItem("mobile", mobile);
}

export const getMobile = () => {
    return localStorage.getItem("mobile");
}

export const setToken = (token) => {
    localStorage.setItem('token', token);
    client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}


export const setAdminToken = () => {
    localStorage.setItem('adminToken', localStorage.getItem('token'));
    //client.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
export const setReturnToAdmin = () => {
    localStorage.setItem('token', localStorage.getItem('adminToken'));
    client.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`;
    localStorage.setItem('adminToken', null);
}

const removeToken = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('adminToken');
    client.defaults.headers.common['Authorization'] = "";
}

export const login = async (values) => {
    client.defaults.headers.common['Authorization'] = ``;
    const { data } = await client.post(`Authentication/LoginUser`, values);
    // if(data?.userInfo?.data?.requiredChangePassword === true ){
    //     window.location.replace("/change-password")
    //     changeForcePassword= true
    // }
    return data;
}

export const loginWithUserId = async (id) => {
    //client.defaults.headers.common['Authorization'] = ``;
    const { data } = await client.get(`User/LoginWithUserId/${id}`);

    return data;
}

export const me = async () => {
    const { data } = await client.post(`Public/UserInfo`);

    if (data.userInfo.data.requiredChangePassword === true) {
        changeForcePassword = true
    }
    return data;
}

export const logout = async (values) => {
    const { data } = await client.post(`Authentication/Logout`, values);
    removeToken();
    return data;
}

export const register = async (values) => {
    const { data } = await client.post(`Authentication/RegisterUser`, values);
    return data;
}

export const GetChangePasswordToken = async (mobile) => {
    const { data } = await client.get(`Authentication/GetChangePasswordToken/${mobile}`);
    return data;
}

export const ConfirmChangePasswordCode = async (values) => {
    const { data } = await client.post(`Authentication/ConfirmChangePasswordCode`, values);
    return data;
}
export const UserChangePassword = async (values) => {
    const { data } = await client.post(`Authentication/UserChangePassword`, values);
    return data;
}

export const checkUserIsValidate = async (values) => {
    const { data } = await client.post(`Authentication/CheckUserIsValidate`, values);
    return data;
}

export const forgetPassword = (values) => {
    const { data } = client.post(`forget-password`, values);
    return data;
}

export const resetPassword = (values) => {
    const { data } = client.post(`Authentication/resetPassword`, values);
    return data;
}


export const verifyUser = async (values) => {
    const { data } = await client.post(`Authentication/VerifyUser`, values);
    return data;
}
export const UserReferencerList = async () => {
    const { data } = await client.get(`Authentication/GetUserReferencerList`);
    return data;
}

export const verifyEmail = () => {
    const { data } = client.get(`verify-email`);
    return data;
}

export const ChangeUserPasswordByUser = async (values) => {
    const { data } = await client.post(`User/ChangeUserPasswordByUser`, values);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}

export const ChangeUserPassword = async (id) => {
    const { data } = await client.get(`User/ChangeUserPassword/${id}`);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}
export const ChangeActiveStatus = async (id) => {
    const { data } = await client.get(`User/ChangeActiveStatus/${id}`);
    if (data.status === 200) {
        changeForcePassword = false
    }
    return data;
}
// common

export const languages = async () => {
    const { data } = await client.get(`Common/GetListLanguage`);
    return data;
}

// User
export const users = async (values) => {
    const { data } = await client.post(`User/UserList`, values);
    return data;
}
export const userSubSet = async (values) => {
    const { data } = await client.post(`User/SubSetUser`, values);
    return data;
}

export const user = async (id) => {
    const { data } = await client.get(`User/UserItem/${id}`);
    return data;
}

export const createUser = async (values) => {
    const { data } = await client.post(`User/AddNewUser`, values)
    return data;
}

export const updateUser = async (id, values) => {
    const { data } = await client.patch(`User/EditUser/${id}`, values)
    return data;
}
export const uploadExcelFile = async (values) => {
    const { data } = await client.post(`User/UploadExcelFile`, values)
    return data;
}
export const deleteUser = async (id) => {
    const { data } = await client.delete(`User/RemoveUser/${id}`)
    return data;
}

export const updateUserRole = async (values) => {
    const { data } = await client.patch(`User/UpdateUserRole`, values)
    return data;
}

// permission category

export const permissionCategories = async (values) => {
    const { data } = await client.post(`PermissionCategory/PermissionCategoryList`, values);
    return data;
}

export const permissionCategory = async (id) => {
    const { data } = await client.get(`PermissionCategory/PermissionCategoryItem/${id}`);
    return data;
}

export const createPermissionCategory = async (values) => {
    const { data } = await client.post(`PermissionCategory/AddPermissionCategory`, values);
    return data;
}

export const deletePermissionCategory = async (id) => {
    const { data } = await client.delete(`PermissionCategory/RemovePermissionCategory/${id}`);
    return data;
}

export const updatePermissionCategory = async (id, values) => {
    const { data } = await client.patch(`PermissionCategory/EditPermissionCategory/${id}`, values);
    return data;
}

export const permissionCategoryList = async () => {
    const { data } = await client.get(`Permission/GetPermissionWithCategoryList`);
    return data;
}

// Role
export const roles = async (values) => {
    const { data } = await client.post(`Role/RoleList`, values);
    return data;
}

export const role = async (id) => {
    const { data } = await client.get(`Role/GetRoleItem/${id}`);
    return data;
}

export const createRole = async (values) => {
    const { data } = await client.post(`Role/AddRole`, values);
    return data;
}

export const deleteRole = async (id) => {
    const { data } = await client.delete(`Role/RemoveRole/${id}`);
    return data;
}

export const updateRole = async (id, values) => {
    const { data } = await client.patch(`Role/EditRole/${id}`, values);
    return data;
}

export const updateRolePermission = async (values) => {
    const { data } = await client.patch(`Role/UpdateRolePermission`, values);
    return data;
}

//permission
export const permissions = async (values) => {
    const { data } = await client.post(`Permission/PermissionList`, values);
    return data;
}

export const permission = async (id) => {
    const { data } = await client.get(`Permission/GetPermissionItem/${id}`);
    return data;
}

export const createPermission = async (values) => {
    const { data } = await client.post(`Permission/AddPermission`, values)
    return data;
}

export const deletePermission = async (id) => {
    const { data } = await client.delete(`Permission/RemovePermission/${id}`);
    return data;
}

export const updatePermission = async (id, values) => {
    const { data } = await client.patch(`Permission/EditPermission/${id}`, values);
    return data;
}
//City

export const cities = async (values) => {
    const { data } = await client.post(`City/CityList`, values);
    return data;
}
export const city = async (id) => {
    const { data } = await client.get(`City/CityItem/${id}`);
    return data;
}
export const deleteCity = async (id) => {
    const { data } = await client.delete(`City/RemoveCity/${id}`);
    return data;
}
export const createCity = async (values) => {
    const { data } = await client.post(`City/AddCity`, values);
    return data;
}
export const updateCity = async (id, values) => {
    const { data } = await client.patch(`City/EditCity/${id}`, values);
    return data;
}
export const GetAllCityList = async (id) => {
    const { data } = await client.get(`City/GetAllCityList/${id}`);
    return data;
}
//State

export const states = async (values) => {
    const { data } = await client.post(`State/StateList`, values);
    return data;
}
export const stateData = async (id) => {
    const { data } = await client.get(`State/StateItem/${id}`);
    return data;
}
export const deleteState = async (id) => {
    const { data } = await client.delete(`State/RemoveState/${id}`);
    return data;
}
export const createState = async (values) => {
    const { data } = await client.post(`State/AddState`, values);
    return data;
}
export const updateState = async (id, values) => {
    const { data } = await client.patch(`State/EditState/${id}`, values);
    return data;
}
export const GetAllStateList = async () => {
    const { data } = await client.get(`State/GetAllStateList`);
    return data;
}
//Advertisement

export const advertisements = async (values) => {
    const { data } = await client.post(`Advertisement/AdvertisementList`, values);
    return data;
}

export const accountInquieries = async (values) => {
    const { data } = await client.post(`Bank/InquieryHistory`, values);
    return data;
}

export const bankInfoInquieries = async (values) => {
    const { data } = await client.post(`Bank/BankCardValidationList`, values);
    return data;
}

export const bankInfoInquieryItem = async (id) => {
    const { data } = await client.get(`Bank/BankCardValidationItem/${id}`);
    return data;
}

export const myAdvertisements = async (values) => {
    const { data } = await client.post(`Advertisement/MyAdvertisementList`, values);
    return data;
}

export const advertisement = async (id) => {
    const { data } = await client.get(`Advertisement/AdvertisementItem/${id}`);
    return data;
}

export const myAdvertisement = async (id) => {
    const { data } = await client.get(`Advertisement/MyAdvertisementItem/${id}`);
    return data;
}

export const myAdvertisementSocial = async (id) => {
    const { data } = await client.get(`Advertisement/GetSocialInfo/${id}`);
    return data;
}

export const deleteAdvertisement = async (id) => {
    const { data } = await client.delete(`Advertisement/RemoveAdvertisement/${id}`);
    return data;
}

export const settleAdvertisementOrder = async (id) => {
    const { data } = await client.get(`Advertisement/SettleAdvertisementOrder/${id}`);
    return data;
}

export const settleAdvertisementSocialOrder = async (id) => {
    const { data } = await client.get(`Advertisement/SettleAdvertisementSocialOrder/${id}`);
    return data;
}

export const createAdvertisement = async (values) => {
    const { data } = await client.post(`Advertisement/AddAdvertisement`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const createNewAdvertisement = async (values) => {
    const { data } = await client.post(`Advertisement/AddNewAdvertisement`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}
export const createMyAdvertisement = async (values) => {
    const { data } = await client.post(`Advertisement/AddMyAdvertisement`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}

export const createAdminAdvertisement = async (values) => {
    const { data } = await client.post(`Advertisement/AddAdminAdvertisement`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}

export const updateAdvertisement = async (id, values) => {
    const { data } = await client.patch(`Advertisement/EditAdvertisement/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}

export const updateAdvertisementSocial = async (id, values) => {
    const { data } = await client.patch(`Advertisement/EditSocial/${id}`, values);
    return data;
}

export const acceptAdvertisementSocial = async (id) => {
    const { data } = await client.patch(`Advertisement/AcceptSocial/${id}`);
    return data;
}

export const rejectAdvertisementSocial = async (id, message) => {
    const { data } = await client.patch(`Advertisement/RejectSocial/${id}?reason=${message}`);
    return data;
}

export const updateNewAdvertisement = async (id, values) => {
    const { data } = await client.patch(`Advertisement/EditNewAdvertisement/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}

export const updateMyAdvertisement = async (id, values) => {
    const { data } = await client.patch(`Advertisement/EditMyAdvertisement/${id}`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}

export const acceptAdvertisementForPayment = async (id) => {
    const { data } = await client.patch(`Advertisement/InitialAcceptAdvertisement/${id}`);
    return data;
}

export const rejectAdvertisement = async (id, message) => {
    const { data } = await client.patch(`Advertisement/RejectAdvertisement/${id}?reason=${message}`);
    return data;
}

export const ShowAdv = async () => {
    const { data } = await client.get(`Advertisement/ShowAdv/`);
    return data;
}
export const getUserAdv = async (id) => {
    const { data } = await client.get(`Advertisement/GetUserAdv/${id}`);
    return data;
}
//Profile
export const getCurrentUserData = async () => {
    const { data } = await client.get(`User/GetCurrentUserItem`);
    return data;
}
export const GetUserCompleteData = async () => {
    const { data } = await client.get(`User/GetUserCompleteData`);
    return data;
}

export const EditCurrentUser = async (values) => {
    const { data } = await client.patch(`User/EditCurrentUser`, values);
    return data;
}
export const EditCurrentUserBankInfo = async (values) => {
    const { data } = await client.patch(`User/EditCurrentUserBankInfo`, values);
    return data;
}

export const validateBankAccount = async (cardNumber, servicePrice) => {
    const { data } = await client.get(`Bank/ValidateBankCardNumber?cardNumber=${cardNumber}&price=${servicePrice}`);
    return data;
}

export const cardToIbanInquiery = async (values) => {
    const { data } = await client.post(`Bank/CardNumberToIbanInquiery`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}

export const accountToIbanInquiery = async (values) => {
    const { data } = await client.post(`Bank/AccountNumberToIbanInquiery`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}

export const getInquieryResponse = async (id) => {
    const { data } = await client.get(`Bank/InquieryHistoryItem/${id}`);
    return data;
}

export const getTotalPrice = async () => {
    const { data } = await client.post(`Wallet/GetTotalWallet`);
    return data;
}

export const getUserRefrenceCode = async () => {
    const { data } = await client.get(`User/getUserRefrenceCode`);
    return data;
}
export const getInternetPackage = async (id) => {
    const { data } = await client.post(`ChargeMobile/InternetPackages/${id}`);
    return data;
}

export const getInternetPackageArio = async (opType, simType) => {
    const { data } = await client.get(`ChargeMobile/InternetPackagesArio?opType=${opType}&simType=${simType}`);
    return data;
}

export const getInternetPackageMobtakeran = async (opType, simType) => {
    const { data } = await client.get(`ChargeMobile/InternetPackagesMobtakeran?opType=${opType}&simType=${simType}`);
    return data;
}

export const GetBillPaymentStatus = async (id) => {
    const { data } = await client.get(`ChargeMobile/GetBillPaymentStatus/${id}`);
    return data;
}
export const chargeMobile = async (values) => {
    const { data } = await client.post(`ChargeMobile/ChargeMobile`, values);
    return data;
}

export const chargeMobileArio = async (values) => {
    const { data } = await client.post(`ChargeMobile/ChargeMobileArio`, values);
    return data;
}

export const chargeMobileMobtakeran = async (values) => {
    const { data } = await client.post(`ChargeMobile/ChargeMobileMobtakeran`, values);
    return data;
}

export const GetBillStatus = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetBillStatus`, values);
    return data;
}
export const PayBill = async (values) => {
    const { data } = await client.post(`ChargeMobile/PayBill`, values);
    return data;
}

export const getSearchUser = async (values) => {
    const { data } = await client.post(`User/GetSearchUser`, values);
    return data;
}

//Plan1
export const ListUserPlan1 = async () => {
    const { data } = await client.get(`Plan1/ListUserPlan1`);
    return data;
}
export const UpgradeUserPlan1 = async () => {
    const { data } = await client.get(`Plan1/UpgradeUserPlan1`);
    return data;
}
export const GetAllCommissionForUser = async (values) => {
    const { data } = await client.post(`Plan1/GetAllCommissionForUser`, values);
    return data;
}
export const GetLockCommissionForUser = async () => {
    const { data } = await client.get(`Plan1/GetLockCommissionForUser`);
    return data;
}

//
//City

export const GetAdminWalletList = async (values) => {
    const { data } = await client.post(`Wallet/GetAdminWalletList`, values);
    return data;
}
export const GetUserWalletList = async (values) => {
    const { data } = await client.post(`Wallet/GetUserWalletList`, values);
    return data;
}
export const RequestPaymentListForAdmin = async (values) => {
    const { data } = await client.post(`Wallet/RequestPaymentListForAdmin`, values);
    return data;
}
export const RequestPaymentListForUser = async (values) => {
    const { data } = await client.post(`Wallet/RequestPaymentListForUser`, values);
    return data;
}
export const AdminChargeWallet = async (values) => {
    const { data } = await client.post(`Wallet/AdminChargeWallet`, values);
    return data;
}
export const AdminChargeWalletList = async (values) => {
    const { data } = await client.post(`Wallet/AdminChargeWalletList`, values);
    return data;
}
export const AdminChargeAdv = async (values) => {
    const { data } = await client.post(`Advertisement/AdminChargeAdv`, values);
    return data;
}
export const AdminChargeAdvList = async (values) => {
    const { data } = await client.post(`Advertisement/AdminChargeAdvList`, values);
    return data;
}

// export const city = async (id) => {
//     const {data} = await client.get(`City/CityItem/${id}`);
//     return data;
// }
// export const deleteCity = async (id) => {
//     const {data} = await client.delete(`City/RemoveCity/${id}`);
//     return data;
// }
// export const createCity = async (values) => {
//     const {data} = await client.post(`City/AddCity`, values);
//     return data;
// }
// export const updateCity = async (id, values) => {
//     const {data} = await client.patch(`City/EditCity/${id}`, values);
//     return data;
// }

//Report
export const CommissionPeriodForAdmin = async (values) => {
    const { data } = await client.post(`Commission/CommissionPeriodForAdmin`, values);
    return data;
}
export const CommissionForAdmin = async (values) => {
    const { data } = await client.post(`Commission/CommissionForAdmin`, values);
    return data;
}
export const UserCommission = async () => {
    const { data } = await client.get(`Commission/UserCommission`);
    return data;
}


export const GetUserInternetChargeListForAdmin = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserInternetChargeListForAdmin`, values);
    return data;
}
export const GetUserInternetChargeList = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserInternetChargeList`, values);
    return data;
}
export const GetUserSimChargeListForAdmin = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserSimChargeListForAdmin`, values);
    return data;
}
export const GetUserSimChargeList = async (values) => {
    const { data } = await client.post(`ChargeMobile/GetUserSimChargeList`, values);
    return data;
}


//RequestPayment
export const AddRequestPaymentCommission = async (values) => {
    const { data } = await client.post(`RequestPayment/AddRequestPaymentCommission`, values);
    return data;
}

export const AddTransferCommissionToWallet = async (values) => {
    const { data } = await client.post(`RequestPayment/AddTransferCommissionToWallet`, values);
    return data;
}

export const CheckRequestPayment = async () => {
    const { data } = await client.post(`RequestPayment/CheckRequestPayment`);
    return data;
}

export const CheckRequestPaymentToWallet = async () => {
    const { data } = await client.post(`RequestPayment/CheckRequestPaymentToWallet`);
    return data;
}

export const GetUserRequestPayment = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestPayment`, values);
    return data;
}

export const GetAccountToIbanList = async (values) => {
    const { data } = await client.post(`Bank/GetAccountToIbanList`, values);
    return data;
}

export const GetCardToIbanList = async (values) => {
    const { data } = await client.post(`Bank/GetCardToIbanList`, values);
    return data;
}

export const GetAccountToIbanAdminList = async (values) => {
    const { data } = await client.post(`Bank/GetAccountToIbanListAdmin`, values);
    return data;
}

export const GetCardToIbanAdminList = async (values) => {
    const { data } = await client.post(`Bank/GetCardToIbanListAdmin`, values);
    return data;
}

export const GetUserRequestPaymentForAdmin = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestPaymentForAdmin`, values);
    return data;
}
export const AddDescriptionRequestPaymentForAdmin = async (values) => {
    const { data } = await client.post(`RequestPayment/AddDescriptionRequestPaymentForAdmin`, values);
    return data;
}
export const GetUserRequestTransferCommissionToWallet = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestTransferCommissionToWallet`, values);
    return data;
}
export const GetUserRequestTransferCommissionToWalletForAdmin = async (values) => {
    const { data } = await client.post(`RequestPayment/GetUserRequestTransferCommissionToWalletForAdmin`, values);
    return data;
}
export const UpdateRequestPaymentStatus = async (values) => {
    const { data } = await client.post(`RequestPayment/UpdateRequestPaymentStatus`, values);
    return data;
}

export const UserTree = async (id) => {
    const { data } = await client.get(`User/UserTree/${id}`);
    return data;
}
export const UserTree2 = async (id) => {
    const { data } = await client.get(`User/UserTree2/${id}`);
    return data;
}
export const UserTree3 = async (id) => {
    const { data } = await client.get(`User/UserTree3/${id}`);
    return data;
}
export const ParentUserTree = async (id) => {
    const { data } = await client.get(`User/ParentUserTree/${id}`);
    return data;
}

//ShopCategory
export const shopCategories = async (values) => {
    const { data } = await client.post(`ShopCategory/ShopCategoryList`, values);
    return data;
}
export const shopCategory = async (id) => {
    const { data } = await client.get(`ShopCategory/ShopCategoryItem/${id}`);
    return data;
}
export const deleteShopCategory = async (id) => {
    const { data } = await client.delete(`ShopCategory/RemoveShopCategory/${id}`);
    return data;
}
export const createShopCategory = async (values) => {
    const { data } = await client.post(`ShopCategory/AddShopCategory`, values);
    return data;
}
export const updateShopCategory = async (id, values) => {
    const { data } = await client.patch(`ShopCategory/EditShopCategory/${id}`, values);
    return data;
}
export const AllShopCategory = async () => {
    const { data } = await client.get(`ShopCategory/AllShopCategory`);
    return data;
}

export const shops = async (values) => {
    const { data } = await client.post(`Shop/ShopList`, values);
    return data;
}
export const shop = async (id) => {
    const { data } = await client.get(`Shop/ShopItem/${id}`);
    return data;
}
export const createShop = async (values) => {
    const { data } = await client.post(`Shop/AddShop`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}



export const ChargeWalletWithIrandargah = async (value) => {
    const { data } = await client.post(`Wallet/ChargeWalletWithIrandargah`, value);
    return data;
}
export const ChargeWalletWithSadad = async (value) => {
    const { data } = await client.post(`Wallet/ChargeWalletWithSadad`, value);
    return data;
}
export const ChargeWalletWithSep = async (value) => {
    const { data } = await client.post(`Wallet/ChargeWalletWithSep`, value);
    return data;
}
export const ChargeWalletVerificationWithIrandargah = async (id) => {
    const { data } = await client.get(`Wallet/ChargeWalletVerificationWithIrandargah/${id}`);
    return data;
}
export const CheckOnlinePaymentWithIrandargah = async (id) => {
    const { data } = await client.get(`Public/CheckOnlinePayment/${id}`);
    return data;
}

//OnlinePaymentBank
export const OnlinePaymentBankList = async (values) => {
    const { data } = await client.post(`OnlinePaymentBank/OnlinePaymentBankList`, values);
    return data;
}
export const OnlinePaymentBankListForAdmin = async (values) => {
    const { data } = await client.post(`OnlinePaymentBank/OnlinePaymentBankListForAdmin`, values);
    return data;
}
export const CheckWalletVerificationWithIrandargah = async (id) => {
    const { data } = await client.post(`Public/IrandargahCallback/${id}`);
    return data;
}

//ChatgeUserWallet
export const GetCountUserWithCategory = async () => {
    const { data } = await client.get(`ChargeUserWallet/GetCountUserWithCategory`);
    return data;
}
export const TransferUserWithCategory = async (values) => {
    const { data } = await client.post(`ChargeUserWallet/TransferUserWithCategory`, values);
    return data;
}
export const GetTransferStatus = async () => {
    const { data } = await client.get(`ChargeUserWallet/GetTransferStatus`);
    return data;
}

export const GetTreeData = async () => {
    const { data } = await client.get(`Public/TreeData`);
    return data;
}
export const getSetting = async () => {
    const { data } = await client.get(`Public/GetSetting`);
    return data;
}

export const getSettingItem = async (title) => {
    const { data } = await client.get(`Public/GetSettingItem?title=${title}`);
    return data;
}

export const ChangeActiveSiteStatus = async () => {
    const { data } = await client.get(`Setting/ChangeActiveSiteStatus`);
    return data;
}
export const SaveSetting = async (values) => {
    const { data } = await client.post(`Setting/SaveSetting`, values, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return data;
}


//Plan3

//Plan1
export const ListUserPlan3 = async () => {
    const { data } = await client.get(`Plan3/ListUserActivePlan3`);
    return data;
}
export const ActivePlan3 = async (id) => {
    const { data } = await client.get(`Plan3/ActivePlan3/${id}`);
    return data;
}

export const ListUserPlan4 = async () => {
    const { data } = await client.get(`Plan4/ListUserActivePlan4`);
    return data;
}
export const ActivePlan4 = async (id) => {
    const { data } = await client.get(`Plan4/ActivePlan4/${id}`);
    return data;
}
export const ListUserPlan = async () => {
    const { data } = await client.get(`Plan/ListUserActivePlan`);
    return data;
}
export const ActivePlan = async (id) => {
    const { data } = await client.get(`Plan/ActivePlan/${id}`);
    return data;
}


//Message

export const messageList = async (values) => {
    const { data } = await client.post(`Message/MessageList`, values);
    return data;
}
export const deleteMessage = async (id) => {
    const { data } = await client.post(`Message/DeleteMessage/${id}`);
    return data;
}
export const messageItem = async (id) => {
    const { data } = await client.get(`Message/MessageItem/${id}`);
    return data;
}

export const createMessage = async (values) => {
    const { data } = await client.post(`Message/AddMessage`, values);
    return data;
}
export const updateMessage = async (id, values) => {
    const { data } = await client.post(`Message/EditMessage/${id}`, values);
    return data;
}
export const userShowMessage = async (values) => {
    const { data } = await client.post(`Message/UserShowMessage`, values);
    return data;
}

// store
// پشتیبانی اختیاری از فیلتر دسته‌بندی سمت سرور
export const getProducts = async (categoryId) => {
    const url = categoryId ? `Product?categoryId=${categoryId}` : `Product`;
    const { data } = await client.get(url);
    return data;
};

export const getProductByIdAsync = async (productId) => {
    const { data } = await client.get(`Product/${productId}`);
    return data;
};

export const getProductCategoriesAsync = async () => {
    const { data } = await client.get("Product/GetAllCategories");
    return data;
};

export const buyProductAsync = async (values) => {
    const { data } = await client.post(`Product/Buy`, values);
    return data;
}

export const payFromCreditFundAsync = async (values) => {
    const { data } = await client.post(`Product/PayFromCreditFund`, values);
    return data;
}

export const isPurchasedAsync = async (productId) => {
    const { data } = await client.get(`Product/IsPurchased/${productId}`);
    return data;
};

export const getFinalPriceAsync = async (productId) => {
    const { data } = await client.get(`Product/FinalPrice/${productId}`);
    return data;
};

export const getAllPurchaseForAdminAsync = async (request) => {
    const { data } = await client.post("Product/GetAllPurchaseForAdmin", request);
    return data;
};
export const getAllPurchaseForUserAsync = async (request) => {
    const { data } = await client.post("Product/GetAllPurchaseForUser", request);
    return data;
};

export const verification = async (values) => {
    const { data } = await client.post(`User/Verification`, values);
    return data;
}
export const getProvicesAsync = async () => {
    const { data } = await client.get(`Location/GetProvinces`);
    return data;
}
export const getCitiesAsync = async (provinceId) => {
    const { data } = await client.get(`Location/GetCities/${provinceId}`);
    return data;
}

export const GetUserContactAsync = async () => {
    const { data } = await client.get(`UserContacts/Get`);
    return data;
}


export const getShipmentAddressAsync = async () => {
    const { data } = await client.get(`ShipmentProductUserAddress/GetCurrentUserAddress`);
    return data;
}

export const createOrUpdateShipmentAddressAsync = async (values) => {
    const { data } = await client.post(`ShipmentProductUserAddress/CreateOrUpdate`, values);
    return data;
}

export const createOrUpdateUserContactAsync = async (values) => {
    const { data } = await client.post(`UserContacts/CreateOrUpdate`, values);
    return data;
}

export const GetAllVerifiedUsersForAdminAsync = async (values) => {
    const { data } = await client.post(`Verification/GetAllVerifiedUsersForAdmin`, values);
    return data;
}

export const GetAllVerifiedBankUsersForAdminAsync = async (values) => {
    const { data } = await client.post(`Verification/GetAllVerifiedBankUsersForAdmin`, values);
    return data;
}
export const GetAllVerifiedUsersAsync = async (values) => {
    const { data } = await client.post(`Verification/GetAllVerifiedUsers`, values);
    return data;
}

export const GetAllVerifiedBankUsersAsync = async (values) => {
    const { data } = await client.post(`Verification/GetAllVerifiedBankUsers`, values);
    return data;
}

export const ActiveNewPart1 = async (payload) => {
    const { data } = await client.post(`NewPlans/ActivePart`, payload);
    return data;
};

export const ActiveNewPlan5 = async (payload) => {
    const { data } = await client.post(`NewPlan5/ActivePart`, payload);
    return data;
};

export const GetPlans = async (planId) => {
    const { data } = await client.get("NewPlans/GetPlans", {
        params: { planId }
    });

    return data;
};

export const GetPlan5 = async () => {
    const { data } = await client.get("NewPlan5/GetPlan5");
    return data;
};

export const SaveAgentInsuranceGroupSettings = async (data, userId) => {
    return await client.post(`/AgentInsurance/SaveGroupSettings/${userId}`, data);
};

export async function GetAgentInsuranceGroupSettings(userId) {
    const { data } = await client.get(`/AgentInsurance/GetGroupSettings`, {
        params: { userId }
    });
    return data;
}

export const PurchaseDiamondPlan = async () => {
    const { data } = await client.post("/DiamondPlan/purchase");
    return data;
};

export const GetDiamondWalletBalance = async () => {
    const { data } = await client.get("/DiamondPlan/wallet-balance");
    return data;
};

export const GetDiamondAdvertisements = async () => {
    const { data } = await client.get("/DiamondPlan/advertisements");
    return data;
};

export const GetDiamondDetailsAsync = async () => {
    const { data } = await client.get("/DiamondPlan/diamond-plan-details");
    return data;
};

export const InquireGasAsync = async (values) => {
    const { data } = await client.post(`/Gabs/InquiresGas`, values);
    return data;
}

export const PeymentGasAsync = async (values) => {
    const { data } = await client.post(`/Gabs/PaysGas`, values);
    return data;
}

export const GetGasCallback = async (params) => {
    // params: { payment_id, amount, status, reference_number?, trace_number? }
    const { data } = await client.get("/Gabs/CallbackGas", { params });
    return data;
};


// 1. استعلام قبض آب
export const InquireWaterAsync = async (parameter) => {
    const payload = typeof parameter === 'object' ? parameter : { parameter };
    const { data } = await client.post('/Gabs/WaterInquire', payload);
    return data;
};

// 2. استعلام قبض برق
export const InquireElectricityAsync = async (parameter) => {
    const payload = typeof parameter === 'object' ? parameter : { parameter };
    const { data } = await client.post('/Gabs/ElectricityInquire', payload);
    return data;
};

// 3. استعلام قبض گاز با شماره اشتراک
export const InquireGasBySubscriptionAsync = async (parameter) => {
    const payload = typeof parameter === 'object' ? parameter : { parameter };
    const { data } = await client.post('/Gabs/GasInquireBySubscription', payload);
    return data;
};

// 4. استعلام قبض گاز با شناسه قبض
export const InquireGasByBillIdAsync = async (parameter) => {
    const payload = typeof parameter === 'object' ? parameter : { parameter };
    const { data } = await client.post('/Gabs/GasInquireByBillId', payload);
    return data;
};

export const InquireMobileAsync = async (values) => {
    const { data } = await client.post('/Gabs/MobileInquireNow', values);
    return data;
};

export const PeymentMobileAsync = async (values) => {
    const { data } = await client.post(`/Gabs/PaysMobile`, values);
}

export const PaymentWatersync = async (values) => {
    const { data } = await client.post('/Gabs/WaterPayment', values);
    return data;
};

export const GetMobileCallback = async (params) => {
    // params: { payment_id, amount, status, reference_number?, trace_number? }
    const { data } = await client.get("/Gabs/CallbackMoile", { params });
}
export const PaymentElctricityAsync = async (values) => {
    const { data } = await client.post('/Gabs/ElectricityPayment', values);
    return data;
};


export const PaymentGasAsync = async (values) => {
    const { data } = await client.post('/Gabs/GasInquireByBillIdPayment', values);
    return data;
};

export const PaymentMobileAsync = async (values) => {
    const { data } = await client.post('/Gabs/MobilePayPayment', values);
    return data;
};

//پذیرندگان
export const getCategoriesAsync = async (params) => {
    const { data } = await client.get("/Acceptor/categories", { params });
    return data
}

export const searchAcceptorsAsync = async (params) => {
    const { data } = await client.get("/Acceptor/search-stores", { params });
    return data
}

export const getStoreDetailAsync = async (id) => {
    // آدرس دقیقاً باید با مسیر کنترلرتان همخوانی داشته باشد
    const { data } = await client.get(`/Acceptor/GetStoreDetail/${id}`);
    return data;
};


export default client;